"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DefaultTransition;

var _react = _interopRequireDefault(require("react"));

var _Cover = _interopRequireDefault(require("./Cover"));

var _Fade = _interopRequireDefault(require("./Fade"));

var _PaintDrip = _interopRequireDefault(require("./PaintDrip"));

var _Swipe = _interopRequireDefault(require("./Swipe"));

var _gatsbyPluginTransitionLink = _interopRequireDefault(require("gatsby-plugin-transition-link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DefaultTransition(props) {
  return _react.default.createElement(_react.default.Fragment, null, props.cover && _react.default.createElement(_Cover.default, props, props.children), props.fade && _react.default.createElement(_Fade.default, props, props.children), props.paintDrip && _react.default.createElement(_PaintDrip.default, props, props.children), props.swipe && _react.default.createElement(_Swipe.default, props, props.children), !props.cover && !props.fade && !props.paintDrip && !props.swipe && _react.default.createElement(_gatsbyPluginTransitionLink.default, {
    to: props.to
  }, props.children));
}